exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".collapsible[data-v-6fa30bc0]{background-color:#eee;color:#444;cursor:pointer;padding:18px;width:100%;border:none;text-align:left;outline:none;font-size:15px}.active[data-v-6fa30bc0],.collapsible[data-v-6fa30bc0]:hover{background-color:#ccc}.content[data-v-6fa30bc0]{padding:0 18px;display:none;overflow:hidden;background-color:#f1f1f1}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/vue-loader/lib/style-compiler?{"optionsId":"0","vue":true,"id":"data-v-6fa30bc0","scoped":true,"sourceMap":false}!./~/sass-loader/lib/loader.js!./~/vue-loader/lib/selector.js?type=styles&index=0!./App/Components/Report/AssetProducts.vue
// module id = 984
// module chunks = 0